import React from "react";
import { useLocation, useNavigate } from "react-router";
import { ToggleGroup, ToggleGroupItem } from "@exiftrator/shared/components/ui";
import { useAppContext } from "../../contexts/AppContext";
import { useBasePath } from "../../contexts/BasePathContext";

function CalendarViewToggle({ calendarMode, onCalendarModeChange }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { stripBase, appPath } = useBasePath();
  const { calendarViewMode, setCalendarViewMode } = useAppContext();
  const path = stripBase(location.pathname);
  const fallbackCalendarMode = calendarViewMode === "weekly" ? "weekly" : "monthly";
  const activeCalendarMode = calendarMode ?? fallbackCalendarMode;
  const activeValue = activeCalendarMode;

  const setCalendarMode = (nextMode) => {
    if (typeof onCalendarModeChange === "function") {
      onCalendarModeChange(nextMode);
      return;
    }
    setCalendarViewMode(nextMode);
  };

  const handleValueChange = (nextValue) => {
    if (!nextValue) return;

    setCalendarMode(nextValue);
    if (!path.startsWith("/calendar")) {
      navigate(appPath("/calendar"));
    }
  };

  return (
    <ToggleGroup
      type="single"
      value={activeValue}
      onValueChange={handleValueChange}
      variant="outline"
      size="sm"
      spacing={0}
    >
      <ToggleGroupItem value="monthly">Month</ToggleGroupItem>
      <ToggleGroupItem value="weekly">Week</ToggleGroupItem>
    </ToggleGroup>
  );
}

export default CalendarViewToggle;
